export default defineNuxtPlugin(async () => {
  const user = useUserStore()
  const { canUseVoiceCalls } = useFeatureFlags()
  const { connect, disconnect } = useCallEventStream()
  const { getEffectiveAuthToken } = useEffectiveAuthToken()

  // Skip when there is no session yet. Otherwise getUserServices() runs
  // unauthenticated on the login page, 401s, and poisons the memoized
  // userServicesPromise, which breaks the first login.
  const authToken = await getEffectiveAuthToken()
  if (!authToken) { return }

  await user.getUserServices()

  if (canUseVoiceCalls.value) {
    connect()
  }

  if (import.meta.hot) {
    import.meta.hot.dispose(() => disconnect())
  }
})
